import { CHANGE_VECTOR_PREVIEW_IMAGE } from '../state/editor/modules/ui/vector/actions.js';

export const actionSanitizer = (action) =>
    action.type === CHANGE_VECTOR_PREVIEW_IMAGE
        ? { ...action, payload: { _note: 'sanitized!', image: '<<IMAGE>>' } }
        : action;
